<template>
  <div class="bg-light-gray rounded py-5">
    <div class="row justify-content-center">
      <div class="col col-md-8 text-center">
        <!--
        :class="{
          'col-md-6': data.image,
          'col-md-12': !data.image,
        }"
        -->
        <div class="mb-3">
          <h1 v-if="data.title">
            {{ data.title }}
          </h1>
          <h4 class="c-coral" v-if="data.subtitle">
            {{ data.subtitle }}
          </h4>
        </div>
        <div v-if="data.description" v-html="data.description"></div>
        <a class="btn btn-brand" :href="data.button_link" target="_blank">
          {{ data.button_text }}
        </a>
      </div>
      <!--
      <div class="col col-md-6 text-center" v-if="data.image">
        <img class="image img-fluid" :src="data.image_obj.storage_url" />
      </div>
      -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudioSignUpBannerPreview',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.image {
  max-height: 400px;
  border-radius: $border-radius;
}
</style>
